import React from 'react';
import PropTypes from 'prop-types';
import { HeaderContainer } from './styling';
import LogoDisplay from './LogoDisplay';

function BetaPageHeader({ isNormalScreenSize, scheme }) {
  return (
    <HeaderContainer>
      <LogoDisplay isNormalScreenSize={isNormalScreenSize} scheme={scheme} />
    </HeaderContainer>
  );
}

BetaPageHeader.propTypes = {
  isNormalScreenSize: PropTypes.bool.isRequired,
  scheme: PropTypes.string.isRequired,
};

export default BetaPageHeader;
